import { Component, inject, OnInit, Signal } from '@angular/core';
import { CoreModule, User as TvUser } from '@toevla-webapplications/core';
import { TranslateModule } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IvvaStore } from '../../store/store.model';
import { UserService } from '../../services/user/user.service';
import OFFERS_ACTIONS from '../../store/offers/offers.actions';
import { Router } from '@angular/router';
import { Toast } from '../../services/toasts/toast.model';
import { ToastsService } from '../../services/toasts/toasts.service';
import { ToastComponent } from '../../components/toast/toast.component';
import { environment } from '../../../environments/env.uat';

import { SessionKeeperComponent, SessionKeeperService } from '@toevla/session-keeper';

@Component({
    selector: 'ivva-wrapper',
    imports: [CoreModule, TranslateModule, ToastComponent, SessionKeeperComponent],
    templateUrl: './wrapper.component.html',
    styleUrls: ['./wrapper.component.scss']
})
export class WrapperComponent implements OnInit {
	user$: Observable<TvUser | null>;
	toasts: Signal<Toast[]>;

	readonly #router = inject(Router);
	readonly #sessionKeeperService = inject(SessionKeeperService);
	readonly #store = inject(Store<IvvaStore>);
	readonly #toastsService = inject(ToastsService);
	readonly #userService = inject(UserService);

	ngOnInit() {
		this.toasts = this.#toastsService.toasts;

		this.user$ = this.#store.select('offers', 'user').pipe(
			map((user) => {
				if (user) {
					this.#sessionKeeperService.start({
						method: 'GET',
						url: '/rest/user',
					});

					this.checkRedirect();

					return {
						contact: {
							person: {
								firstName: user.firstName,
								lastName: user.lastName,
							},
						},
					} as TvUser;
				}

				return null;
			})
		);
	}

	logout() {
		this.#userService.logout().subscribe({
			next: () => {
				this.#store.next(OFFERS_ACTIONS.setUser({ user: null }));
				this.#sessionKeeperService.stop();
				document.location.href = environment.acmIdmLogoutUrl;
			},
			error: () => {
				this.#store.next(OFFERS_ACTIONS.setUser({ user: null }));
				this.#sessionKeeperService.stop();
				document.location.href = environment.acmIdmLogoutUrl;
			},
		});
	}

	private checkRedirect() {
		const str = localStorage.getItem('redirect');

		if (str) {
			try {
				const data = JSON.parse(str);

				const FIVE_MINUTES = 5 * 60 * 1_000;
				const fiveMinutesAgo = Date.now() - FIVE_MINUTES;

				if (data.time > fiveMinutesAgo) {
					if (data.link) {
						this.#router.navigate([data.link]);
					}
				}
			} catch {}
		}

		localStorage.removeItem('redirect');
	}
}
